import IconButton from '@mui/material/IconButton';
import { CashierPath } from '@ps/web-pam-types';
import { useNavigate } from '@ps/web-shared-components';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import BalanceAmount from '@swf/components/CurrencyAmount/BalanceAmount';

import HideIcon from '../assets/eye-hide.svg';
import ShowIcon from '../assets/eye-show.svg';

import { TXTCLI_Show_Balance } from './BalanceDisplay.messages.json';
import styles from './BalanceDisplay.scss';

interface BalanceDisplayProps {
  balance: number;
  userId: string;
  onUserNameClick: () => void;
}

const BalanceDisplay: React.FC<BalanceDisplayProps> = ({ balance, userId, onUserNameClick }) => {
  const [isVisible, setIsVisible] = useState(true);
  const Icon = isVisible ? HideIcon : ShowIcon;
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  const toggleVisibility = () => {
    setIsVisible((prev) => !prev);
  };

  const balanceString = balance.toFixed(2);
  const integerPartLength = balanceString.split('.')[0].length;

  const maskedBalance = '•'.repeat(integerPartLength + (balanceString.includes('.') ? 1 : 0));
  return (
    <div className={styles.container}>
      <div className={styles.userId} onClick={onUserNameClick}>
        {userId}
      </div>
      <div className={styles.subContainer}>
        <span className={styles.balance} onClick={() => navigate(CashierPath.Cashier)}>
          {isVisible ? <BalanceAmount value={balance} /> : maskedBalance}
        </span>
        <IconButton
          onClick={toggleVisibility}
          aria-label={formatMessage(TXTCLI_Show_Balance)}
          size="small"
        >
          <Icon width="20px" height="20px" />
        </IconButton>
      </div>
    </div>
  );
};

export default BalanceDisplay;
